import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import { Typography, Grid } from '@material-ui/core';
import Page from '../components/Page';
import PaperContainer from '../components/PaperContainer';
import styled from '../utils/styled';
import Section from '../components/Section';
import featureImage from './iStock_000037546596_Large.jpg';

const content = (
  <div>
    <PaperContainer headerText="Commitment">
      We offer a free, no obligation in-home consultation to thoroughly assess your individual care needs and recommend appropriate home care services.
    </PaperContainer>
    <PaperContainer headerText="Confidence">
      Our home care services and the respective costs are clearly spelled out in your Service Agreement — not a long term contract.
    </PaperContainer>
    <PaperContainer headerText="Quality">
      Your Caregiver will have undergone our highly personalized screening system, including interviews, thorough background check, training and follow-up.
    </PaperContainer>
    <PaperContainer headerText="Choice">
      You will have the opportunity to interview any Caregiver we refer to you for your home care.
    </PaperContainer>
    <PaperContainer headerText="Comfort">
      We promise to find you a Caregiver you trust - a dedicated person who makes you feel completely comfortable.
    </PaperContainer>
    <PaperContainer headerText="Satisfaction">
      We perform announced and unannounced home visits and telephone follow-ups to ensure your continued home care satisfaction.
    </PaperContainer>
  </div>
);

const About = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="About - Home Care Plus" />
        <Page
          image={featureImage}
          title={"About"}
        >
          { content }
        </Page>
      </Grid>
    </Section>
  );
};
export default About;



// WEBPACK FOOTER //
// ./src/pages/about.js